// This file contains configuration options related to the DOM
// e.g. button IDs to attach listener
//
export const DOM_IDS = {
  singinBtn: "sign-in-btn",
  appOrigin: "app-origin",
  loginStatus: "login-status",
  // div is shown or hidden if there are no targets (display: block/none)
  targetsWrapper: "app-scope",
  // Element to display the delegation targets (canister IDs)
  targets: "app-targets",

  showPopup: true,
};
